<div class="cf_main">
	<search-bar [navigateToResultsOnSearch]="false"></search-bar>

	<summary [hidden]="inCompanyMode" [summary]="activeSummary"></summary>
	<filter [singleSector]="inAssetMode"></filter>
	<summary [hidden]="inAssetMode" [summary]="activeSummary"></summary>
	<explore [summary]="activeSummary" [assetSummary]="assetSummary"></explore>
	<company-overview
		[hidden]="inAssetMode"
		[summary]="activeSummary"
		[tagCounts]="tagCounts"
	></company-overview>
</div>
